import React from "react";
import { Card, Statistic, Col } from "antd";

export const CardStatisticMarketing = ({data, totalOrders, deliveredOrders, conversionRate}) => {

  const uniquephoneNumbers = data?.reduce((accumulator, currentClient) => {
    const phoneNumber = currentClient.phoneNumber
      ?.replace(/\s/g, "")
      ?.replace(/-/g, "");
    if (phoneNumber && !accumulator?.includes(phoneNumber)) {
      return [...accumulator, phoneNumber];
    } else {
      return accumulator;
    }
  }, []);

  const numberOfClients = uniquephoneNumbers ? uniquephoneNumbers.length : [];

  const cardInfo = [
    {
      title: "Totales Ordenes",
      value: totalOrders > 0 ? `S/ ${totalOrders.toFixed(2)}` : ' - ',
    },
    {
      title: "Ordenes entregadas",
      value: deliveredOrders > 0 ? deliveredOrders : ' - ',
    },
    {
      title: "Tasa de conversion",
      value: conversionRate > 0 ? `${conversionRate}%` : ' - ',
    },
    {
      title: "Clientes Totales",
      value: numberOfClients > 0 ? numberOfClients : ' - ',
    },
  ];

  return (
    <div className="py-4 mx-auto">
      <div className="flex flex-wrap justify-center mx-auto">
        {cardInfo.map((card, index) => (
          <Col key={index}>
           <Card bordered={true} className="text-center mb-4 w-96 lg:w-60">
              <Statistic
               className="text-sm"
                title={card.title}
                value={card.value}
                suffix={card.suffix}
              />
            </Card>
           </Col>
         ))}
      </div>
    </div>
  );
};
